import { Observable, ReplaySubject } from "rxjs";
import * as rxjsOperators from "rxjs-operators";
import entityService from "services/entity";

import storageService, { StorageService } from "./storage";
import ventureService from "./venture";

export interface ISelection {
  id: number;
  name: string;
}

export class SelectedVentureService {
  private profile$: ReplaySubject<ISelection>;

  constructor(private storageService: StorageService) {
    this.profile$ = new ReplaySubject(1);

    this.storageService
      .get("profile")
      .pipe(rxjsOperators.logError())
      .subscribe((profile) => this.profile$.next(profile));
  }

  public getSelectedVenture(): Observable<ISelection> {
    return this.profile$.pipe(
      rxjsOperators.distinctUntilChanged((x, t) =>
        !!x && !!t ? x.id === t.id : x === t
      )
    );
  }

  public setProfile(selection: ISelection | null): Observable<ISelection> {
    return this.storageService.set("profile", selection).pipe(
      rxjsOperators.tap(() => {
        selection && entityService.refreshEntities();
      }),
      rxjsOperators.tap(() => {
        selection && ventureService.refreshVenture();
      }),
      rxjsOperators.tap(() => {
        this.profile$.next(selection);
      })
    );
  }

  public clearProfile(): Observable<void> {
    return this.setProfile(null).pipe(rxjsOperators.map(() => null));
  }
}

const selectedVentureService = new SelectedVentureService(storageService);
export default selectedVentureService;